/** @format */

export const SELL_BALANCE_ENABLED_FLAG = 'BOO-3170-(sell-balance)';
export const ACCESSORIES_CHECKLIST_FLAG =
    'LOVE-1153-(sell-journey-accessories-checklist)';
export const VAT_REGISTERED_BUY_FLAG = 'BOO-3485-(vat-registered-buy)';
